import { render, staticRenderFns } from "./ItemMasterPage.vue?vue&type=template&id=4f4c41c4"
import script from "./ItemMasterPage.vue?vue&type=script&lang=ts"
export * from "./ItemMasterPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports